import styled, { css } from 'styled-components'
import { containerDefault } from '../../../lib/styles/Container'
import * as React from 'react'
import { StyledNavigationLink } from '../NavigationLink/styled'

export const Wrapper = styled.nav`
  background-color: ${props => props.theme.colors.white[1]};
  transition: box-shadow 0.2s ease-in-out;
`

export const Container = styled.div`
  ${containerDefault}
  margin-inline: auto;
  justify-content: space-evenly;
`

export const NavList = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
  
`

export const Group = styled.ul<{ isDesktop?: boolean; isMobile?: boolean }>`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      display: none;

      @media screen and (min-width: 1024px) {
        display: flex;
      }
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      display: flex;

      @media screen and (min-width: 1024px) {
        display: none;
      }
    `}
`

export const LinkWrapper = styled.div`
  ${StyledNavigationLink}.active {
    font-weight: bold;
  }
  &:hover ${StyledNavigationLink}:before {
    left: -2px;
    right: -2px;
    top: -2px;
    bottom: -2px;
    background-color: var(--c-theme-6);
  }
`

export const Text = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const IconWrapper = styled.span`
  flex: 0 0 auto;
`
